import React from 'react'
import PropTypes from 'prop-types'

import defaultProps from '../../../utils/propTypes/defaultProps'

import SmallContentContainer from '../../_layouts/SmallContentContainer/SmallContentContainer'
import AllroundContainer from '../../_layouts/AllroundContainer'

const T007 = ({ publisher, author, label }) => {
  let contactLabel = publisher ? 'Herausgeber' : 'Autor'
  if (label) contactLabel = label

  return (
    <AllroundContainer dataTrackingName="T007">
      <SmallContentContainer isArticleContainer className="flex justify-between gap-24">
        {publisher ? (
          <>
            <div>
              <p className="text-14 leading-20 text-828b91">{contactLabel}</p>
              <p className="text-16 leading-24">{publisher.name}</p>

              {!!publisher.logo && (
                <img src={publisher.logo.url} alt={publisher.logo.alt} loading="lazy" className="hidden 600:block" />
              )}
            </div>
          </>
        ) : (
          <div>
            <p className="text-14 leading-20 text-828b91">{contactLabel}</p>
            <p className="text-16 leading-24">{`${author.name}, ${author.jobTitle}`}</p>
          </div>
        )}
      </SmallContentContainer>
    </AllroundContainer>
  )
}

T007.propTypes = {
  author: PropTypes.shape({
    name: PropTypes.string,
    jobTitle: PropTypes.string,
  }),
  publisher: PropTypes.shape({
    name: PropTypes.string,
    logo: PropTypes.shape({
      url: PropTypes.string,
      alt: PropTypes.string,
    }),
  }),
  label: PropTypes.string,
}

T007.defaultTypes = {
  author: {
    name: defaultProps.NAME,
    jobTitle: 'jobTitle nicht gesetzt',
  },
  sources: defaultProps.DESCRIPTION_RICH,
}

export default T007
